import axios from 'axios'

const api = axios.create({
  baseURL: '',
  timeout: 120000
})

api.interceptors.request.use(config => {
  // 管理后台接口优先使用 admin_token
  var isAdminApi = config.url && config.url.indexOf('/api/admin') !== -1
  var token = isAdminApi
    ? (localStorage.getItem('admin_token') || localStorage.getItem('token'))
    : localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

api.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response && error.response.status === 401) {
      var status = error.response.status
      var isAdminPage = window.location.hash.indexOf('#/manage') !== -1
      if (status === 401) {
        if (isAdminPage) {
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_username')
          window.location.hash = '#/manage'
        } else {
          localStorage.removeItem('token')
          localStorage.removeItem('username')
          window.location.hash = '#/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

export default api
